import React from 'react';
import {Route, Routes, Link} from 'react-router-dom';
import { Layout, Typography, Space } from 'antd';

import { Navbar, Homepage, Cryptocurrencies, CryptoDetails, News } from './components';
import './App.css';

const App = () => {
  return (
    
    <div className="app">
        <div className="navbar">
            <Navbar/>
        </div>

        <div className="main">
            <Layout>
            
                <div className="routes">
                    <Routes>
                        <Route exact path= "/" element={<Homepage/>} />
                        <Route exact path= "/cryptocurrencies" element={<Cryptocurrencies/>} />
                        <Route exact path= "/crypto/:uuid" element={<CryptoDetails/>} />
                        <Route exact path= "/news" element={<News/>} />
                    </Routes>
                </div>
                
            </Layout>
        
        
        <div className="footer">
            <Typography.Title level={5} style={{ color: 'white', textAlign: 'center'}}>
                Crypton- A World of Crypto <br/>
                Made with ❤ by <a href="https://www.linkedin.com/in/jaskaran-singh-543136147/">Jaskaran Singh</a> 
            </Typography.Title>
            <Space>
                <Link to="/">Home</Link>
                <Link to="/cryptocurrencies">Cryptocurrencies</Link>
                <Link to="/news">News</Link>
            </Space>
        </div>
        </div>
    </div>
  )
}

export default App